import { render, staticRenderFns } from "./SmallCurrencyInput.vue?vue&type=template&id=1ab9517c&scoped=true"
import script from "./SmallCurrencyInput.vue?vue&type=script&lang=js"
export * from "./SmallCurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./SmallCurrencyInput.vue?vue&type=style&index=0&id=1ab9517c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9517c",
  null
  
)

export default component.exports